import { render, staticRenderFns } from "./vsButton.vue?vue&type=template&id=77308ac0&lang=html&"
import script from "./vsButton.vue?vue&type=script&lang=js&"
export * from "./vsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsButton.vue"
export default component.exports